import React, { useEffect, useMemo, useState } from 'react';
import Modal from '@mui/material/Modal';
import {
  Box,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import DataTable from '../../Common/DataTable';
import { Cancel } from '../../media/images/Cancel';
import { Datatablestyle } from './utils/Constant';
import { FOUsersTable } from './utils/TypeDashboard';
import { getFOUsersList } from './redux/dashboardSlice';
import { RootState } from '../../redux/rootState';
import { PrintIcon } from '../../assets/TableIcons';
import { exportToExcelData } from '../../Common/PageHeader/helper';
import { showErrorToaster } from '../../Common/ComponentToast/ComponentSuccessToasts';
import BidReportDetailsModal from './BidReportDetailsModal';

interface IBidReportModal {
  open: boolean;
  handleClose: () => void;
}

export default function BidReportModal({
  open, handleClose,
}: IBidReportModal) {
  const dispatch = useDispatch();
  const [selectedUser, setSelectedUser] = useState('');

  useEffect(() => {
    dispatch(getFOUsersList());
  }, []);

  const { foUsersList } = useSelector((state:RootState) => state.dashboardReducer);

  const foUsers = useMemo(() => foUsersList?.map((item) => ({
    id: item?.UserId,
    action: 'eye',
    user: item?.FOUserName,
    bidsCreated: item?.TotalBidsCreated,
    bidAmount_nosort: `$ ${item?.TotalBidAmount}`,
  })), [foUsersList]);

  const receivedColumns = [
    { key: 'action', label: 'Action' },
    { key: 'user', label: 'User Name' },
    { key: 'bidsCreated', label: 'Total Bids Created' },
    { key: 'bidAmount_nosort', label: 'Total Bids Amount' },
  ];
  const downloadExcel = () => {
    if (foUsersList?.length > 0) {
      const exportedData = foUsersList?.map((items) => ({
        'User Name': items?.FOUserName,
        'Total Bids Created': items?.TotalBidsCreated,
        'Total Bids Amount ($)': items?.TotalBidAmount,
      }));
      exportToExcelData(
        {
          data: exportedData?.length > 0 ? exportedData : [],
          removeSn: true,
        },
        'Bid_Report-(FO Users List)',
      );
    } else {
      showErrorToaster('No records to export');
    }
  };

  const handleDetails = (id: string) => {
    setSelectedUser(id);
  };

  return (
    <>
      <Modal
        open={open}
        onClose={() => {}}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={Datatablestyle}>
          <div className="customerInfo_container flex-row">
            <div className="customerInfo">
              Bid Report (FO Users List)
            </div>
            <div className="cancel-icon" style={{ cursor: 'pointer' }} onClick={() => handleClose()}>
              <Cancel />
            </div>

          </div>
          <div className="customModalBtnContainer">
            <div />
            <div className="pointCursor" onClick={downloadExcel}>
              <PrintIcon />
            </div>
          </div>
          <DataTable<FOUsersTable>
            data={foUsers || []}
            columns={receivedColumns}
            handleData={() => {}}
            totalRecords={10}
            handleViews={handleDetails}
          />
        </Box>
      </Modal>
      {selectedUser?.length > 0 && (
      <BidReportDetailsModal
        open={selectedUser}
        handleClose={() => setSelectedUser('')}
      />
      )}
    </>
  );
}
